<template>
  <div>
    <div class="todpro">
      <div class="item">
        <div class="info">
          <h3>{{ data.nowtime }}&nbsp;&nbsp;&nbsp;{{ data.weekday }}</h3>
          <p>{{ data.day }}/{{ data.monthday }}</p>
        </div>
      </div>
      <div class="item">
        <div class="info">
          <h3>本月计划</h3>
          <p>{{ data.targetfreight }}</p>
        </div>
      </div>
      <div class="item">
        <div class="info">
          <h3>已达成</h3>
          <p class="overpercentage">
            {{ getPercent(data.allfreight, data.targetfreight) }}
          </p>
        </div>
      </div>
    </div>

    <div class="totData">
      <div class="list lista">
        <div class="item">
          <div class="top">
            <div class="fltit">
              <div class="ico ico1"></div>运费额
            </div>
            <div class="per overpercentage"
              :class="data.allfreight > Math.round(data.targetfreight / data.monthday * Number(data.day)) ? '' : 'pera'">
              {{ getPercent(data.allfreight, data.targetfreight) }}
            </div>
          </div>
          <div class="nums">
            <div class="fla allfreight">{{ data.allfreight }}</div>
            <div class="flb tofreight">-{{ getRound(data.allfreight - Number(data.targetfreight)) }}</div>
          </div>
        </div>
        <div class="item getprofit">
          <div class="top">
            <div class="fltit">
              <div class="ico ico2"></div>毛利额
            </div>
            <div class="profit per" :class="(carData ? carData : data).profit
            > Math.round(data.targetfreight / data.monthday * Number(data.day) * 0.3) ? '' : 'pera'">
              {{ getPercent((carData ? carData : data).profit, data.allfreight) }}</div>
          </div>
          <div class="nums">
            <div class="fla profit">{{ getRound((carData ? carData : data).profit) }}</div>
          </div>
        </div>
      </div>

      <div class="list listb">
        <div class="item">
          <div class="flcon">
            <div class="info">
              <div class="top">
                <div class="fltit">
                  <div class="ico ico3"></div>运单量
                </div>
              </div>
              <div class="nums">
                <div class="flb">已完成</div>
                <div class="fla count4">{{ data.count4 }}</div>
              </div>
            </div>
            <i></i>
          </div>
          <div class="flcon">
            <div class="info">
              <div class="topa">
                <div class="per pers avefreight">{{ data.avefreight }}</div>
              </div>
              <div class="ptit">平均运费</div>
            </div>
            <i></i>
          </div>
          <div class="flcon">
            <div class="info">
              <div class="topa isorder">{{ data.count || 0 }}</div>
              <div class="ptit">运送中</div>
            </div>
            <i></i>
          </div>
          <div class="flcon">
            <div class="info">
              <div class="topa isfreight">{{ (carData ? carData : data).gofreight }}</div>
              <div class="ptit">运送金额</div>
            </div>
          </div>
        </div>

        <div class="item" v-if="(carData ? carData : data).carcount">
          <div class="flcon">
            <div class="info">
              <div class="top">
                <div class="fltit">
                  <div class="ico ico4"></div>运营车辆
                </div>
              </div>
              <div class="nums">
                <div class="flb">总车辆</div>
                <div class="fla carcount">{{ (carData ? carData : data).carcount }}</div>
              </div>
            </div>
            <i></i>
          </div>
          <div class="flcon">
            <div class="info">
              <div class="topa usecarcount">{{ (carData ? carData : data).usecarcount }}</div>
              <div class="ptit">运送中</div>
            </div>
            <i></i>
          </div>
          <div class="flcon">
            <div class="info">
              <div class="topa nousecarcount">{{ (carData ? carData : data).nousecarcount }}</div>
              <div class="ptit">休息中</div>
            </div>
            <i></i>
          </div>
          <div class="flcon">
            <div class="info">
              <!-- 后台没有逻辑 -->
              <div class="topa">0</div>
              <div class="ptit">维修中</div>
            </div>
          </div>
        </div>

        <div class="item" v-if="data.day && showDay">
          <div class="flcon">
            <div class="info">
              <div class="top">
                <div class="fltit">
                  <div class="ico ico4"></div>出勤记录
                </div>
              </div>
              <div class="nums">
                <div class="flb">总天数</div>
                <div class="fla carcount">{{ data.day }}</div>
              </div>
            </div>
            <i></i>
          </div>
          <div class="flcon">
            <div class="info">
              <div class="topa usecarcount">{{ data.driverday }}</div>
              <div class="ptit">出勤天数</div>
            </div>
            <i></i>
          </div>
          <div class="flcon">
            <div class="info">
              <div class="topa nousecarcount">{{ data.noday }}</div>
              <div class="ptit">休息天数</div>
            </div>
            <i></i>
          </div>
          <div class="flcon">
            <div class="info">
              <!-- 后台没有逻辑 -->
              <div class="topa">0</div>
              <div class="ptit">维修天数</div>
            </div>
          </div>
        </div>
      </div>

      <div class="list lista listc">
        <div class="item">
          <div class="top">
            <div class="fltit">
              <div class="ico ico5"></div>出车费用
            </div>
            <div class="per pers daypaypercent">{{ getPercent((carData ? carData : data).alldaypay, data.allfreight) }}
            </div>
          </div>
          <div class="nums">
            <div class="fla alldaypay">{{ getRound((carData ? carData : data).alldaypay) }}</div>
          </div>
        </div>
        <div class="item">
          <div class="top">
            <div class="fltit">
              <div class="ico ico5"></div>固定费用
            </div>
            <div class="per pers fixedpercent">{{ getPercent((carData ? carData : data).allfixed, data.allfreight) }}
            </div>
          </div>
          <div class="nums">
            <div class="fla allfixed">{{ getRound((carData ? carData : data).allfixed) }}</div>
          </div>
        </div>
        <div class="item">
          <div class="top">
            <div class="fltit">
              <div class="ico ico5"></div>维保费用
            </div>
            <div class="per pers repairpercent">{{ getPercent((carData ? carData : data).allrepair, data.allfreight) }}
            </div>
          </div>
          <div class="nums">
            <div class="fla allrepair">{{ getRound((carData ? carData : data).allrepair) }}</div>
          </div>
        </div>
        <div class="item">
          <div class="top">
            <div class="fltit">
              <div class="ico ico5"></div>利润奖金
            </div>
            <div class="per pers jijinpercent">{{ getPercent((carData ? carData : data).jijin, data.allfreight) }}</div>
          </div>
          <div class="nums">
            <div class="fla jijin">{{ getRound((carData ? carData : data).jijin) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DataModal",
  props: {
    data: Object,
    carData: Object,
    showDay: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    getRound(num) {
      let n = num || 0
      return (Math.round(n * 100) / 100)
    },
    getPercent(n, m) {
      let result = Math.round(n / m * 1000) / 10
      if (!m || !n) {
        result = 0
      }
      return result + '%'
    },
  },
};
</script>

<style lang="less" scoped>
.todpro {
  height: auto;
  overflow: hidden;
  margin: 0 auto 20px;
  border-radius: 10px;
  background: linear-gradient(270deg, #00CF9E 0%, #2691FF 100%);

  .item {
    float: left;
    width: 32%;
    height: auto;
    overflow: hidden;
    margin: 0 0 0 1%;

    .info {
      height: auto;
      overflow: hidden;
      margin: 0 auto;
      border-right: 1px solid rgba(255, 255, 255, 0.23);

      h3 {
        height: auto;
        overflow: hidden;
        margin: 20px auto;
        text-align: center;
        line-height: 19px;
        font-size: 14px;
        color: #fff;
        opacity: 0.8;
      }

      p {
        height: auto;
        overflow: hidden;
        margin: 0 auto 20px;
        text-align: center;
        line-height: 29px;
        font-size: 22px;
        color: #fff;
      }
    }

    &:first-child {
      .info {
        h3 {
          opacity: 1;
        }
      }
    }
    &:last-child{
      .info {
        border-right: none;
      }
    }
  }
}

.totData {
  height: auto;
  overflow: hidden;
  margin: 0 auto;
  padding: 20px 20px 0;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 4%);
  background: #fff;

  .list {
    height: auto;
    overflow: hidden;
    margin: 0 auto;

    .item {
      border-radius: 8px;
      background: #F9F9F9;

      .fltit {
        float: left;
        height: 22px;
        line-height: 22px;
        overflow: hidden;
        font-weight: bold;
        font-size: 15px;
        color: #303133;

        .ico {
          float: left;
          width: 5px;
          height: 22px;
          overflow: hidden;
          margin: 0 15px 0 0;
        }

        .ico1 {
          background: #2691FF;
        }

        .ico2 {
          background: #F56C6C;
        }

        .ico3 {
          background: #00C7F0;
        }

        .ico4 {
          background: #92D050;
        }

        .ico5 {
          background: #FFC000;
        }
      }

      .per {
        float: right;
        height: 20px;
        line-height: 20px;
        overflow: hidden;
        padding: 0 13px 0 0;
        font-size: 15px;
        color: #606266;
        background: url(../assets/img/icon_totper_01.png) no-repeat right center;
        background-size: 8px;
      }

      .pera {
        background: url(../assets/img/icon_totper_02.png) no-repeat right center;
        background-size: 8px;
      }

      .pers {
        background: none;
      }

      .nums {
        height: auto;
        overflow: hidden;
        margin: 18px 19px 20px;

        .fla {
          float: left;
          height: 29px;
          line-height: 29px;
          overflow: hidden;
          font-size: 22px;
          color: #303133;
        }

        .flb {
          float: left;
          height: 19px;
          line-height: 19px;
          overflow: hidden;
          margin: 7px 0 0 5px;
          font-size: 14px;
          color: #909399;
        }
      }
    }

    &.lista .item {
      float: left;
      width: 48%;
      height: auto;
      overflow: hidden;
      margin: 0 4% 15px 0;

      .top {
        height: auto;
        overflow: hidden;
        margin: 20px 20px 0 0;
      }

      &.item:nth-child(2n) {
        margin: 0 0 15px 0;
      }
    }

    &.listb .item {
      height: auto;
      overflow: hidden;
      margin: 0 auto 15px;

      .flcon {
        position: relative;
        float: left;
        width: 25%;
        height: auto;
        overflow: hidden;

        .info {
          margin: 0 1px 0 0;
          height: auto;
          overflow: hidden;

          .top {
            height: auto;
            overflow: hidden;
            margin: 19px 0 0 0;
          }

          .topa {
            height: 20px;
            line-height: 20px;
            overflow: hidden;
            margin: 25px auto 20px;
            text-align: center;
            font-size: 15px;
            color: #303133;
          }

          .ptit {
            height: auto;
            line-height: 20px;
            overflow: hidden;
            margin: 0 auto 25px;
            text-align: center;
            font-size: 14px;
            color: #909399;
          }

          .per {
            float: none;
            display: inline-block;
          }
        }

        i {
          display: block;
          position: absolute;
          right: 0;
          top: 33px;
          width: 1px;
          height: 42px;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.06);
        }
      }

      .nums .flb {
        margin: 7px 5px 0 0;
      }
    }
  }

  .Dscreen {
    height: auto;
    overflow: hidden;
    margin: 0 auto 30px;
    border-radius: 7px;
    background: #F5F5F5;

    .itema {
      float: left;
      width: 32%;
      height: auto;
      overflow: hidden;
      margin: 0 0 0 1%;

      .info {
        height: auto;
        overflow: hidden;
        margin: 0 auto;
        border-right: 1px solid rgba(0, 0, 0, 0.05);

        h3 {
          height: 19px;
          line-height: 19px;
          overflow: hidden;
          margin: 20px 0 20px 20px;
          font-size: 14px;
          color: #606266;
        }

        .ps {
          height: 29px;
          line-height: 29px;
          overflow: hidden;
          margin: 0 0 20px 20px;
          font-size: 22px;
          color: #303133;
        }
      }
    }

    .item {
      position: relative;
      float: left;
      width: 25%;
      height: auto;
      overflow: hidden;

      .info {
        height: auto;
        overflow: hidden;
        margin: 0 1px 0 0;

        h3 {
          height: 19px;
          line-height: 19px;
          text-align: center;
          overflow: hidden;
          margin: 20px auto;
          font-size: 14px;
          color: #606266;
        }

        .ps {
          height: 29px;
          line-height: 29px;
          text-align: center;
          overflow: hidden;
          margin: 0 auto 20px;
          font-size: 22px;
          color: #303133;
        }
      }

      i {
        display: block;
        position: absolute;
        right: 0;
        top: 33px;
        width: 1px;
        height: 42px;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }

  .vehdatalist {
    height: auto;
    overflow: hidden;
    margin: 0 auto;

    .vehitem {
      height: auto;
      overflow: hidden;
      margin: 0 auto 20px;
      cursor: pointer;

      .name {
        height: 20px;
        line-height: 20px;
        overflow: hidden;
        margin: 0 auto 10px;
        font-size: 15px;
        color: #303133;
      }

      .vehbar {
        position: relative;
        height: auto;
        overflow: hidden;
        margin: 0 auto;

        .bg {
          position: relative;
          margin: 0 75px 0 0;
          height: 39px;
          overflow: hidden;
          border-radius: 3px;
          background: #F5F5F5;

          .value0 {
            position: absolute;
            left: 0;
            top: 0;
            width: 62px;
            height: 39px;
            line-height: 39px;
            text-align: center;
            overflow: hidden;
            font-size: 14px;
            color: #303133;
          }

          .bga {
            position: absolute;
            left: 62px;
            top: 4px;
            height: 31px;
            overflow: hidden;
            border-radius: 3px;
            background: #2691FF;
            width: 1px;
          }

          .erect {
            position: absolute;
            left: 0;
            top: 0;
            width: 3px;
            height: 37px;
            overflow: hidden;
            border-radius: 1px;
            border: 1px solid #fff;
            background: #67C23A;
            box-shadow: 0px 0px 6px rgb(0 0 0 / 16%);
          }

          .erecta {
            background: #F56C6C;
          }

          .value1 {
            position: absolute;
            left: 0;
            top: 0;
            width: auto;
            height: 39px;
            line-height: 39px;
            text-align: center;
            overflow: hidden;
            font-size: 12px;
            color: #303133;
          }
        }

        .value2 {
          position: absolute;
          right: 0;
          top: 0;
          width: 74px;
          height: 39px;
          line-height: 39px;
          text-align: center;
          overflow: hidden;
          font-size: 14px;
          color: #C0C4CC;
        }
      }
    }
  }

  .vehSheet {
    height: auto;
    overflow: hidden;
    margin: 0 auto 5px;

    .top {
      height: auto;
      overflow: hidden;
      margin: 0 auto 15px;

      .th {
        float: left;
        width: 15.5%;
        height: 19px;
        line-height: 19px;
        text-align: center;
        overflow: hidden;
        margin: 0 0 0 1%;
        font-size: 14px;
        color: #909399;
      }
    }

    .listb {
      height: auto;
      overflow: hidden;
      margin: 0 auto;

      .item {
        height: auto;
        overflow: hidden;
        margin: 0 auto 15px;
        border-radius: 5px;
        background: #F5F5F5;

        .td {
          float: left;
          width: 15.5%;
          height: 47px;
          line-height: 47px;
          text-align: center;
          overflow: hidden;
          margin: 0 0 0 1%;
          font-size: 14px;
          color: #909399;
        }

        .per {
          display: inline-block;
          width: auto;
          padding: 0 13px 0 0;
          height: 20px;
          line-height: 20px;
          overflow: hidden;
          margin: 13px auto 0;
          font-size: 15px;
          color: #606266;
          background: url(../assets/img/icon_totper_01.png) no-repeat right center;
          background-size: 8px;
        }

        .pera {
          background: url(../assets/img/icon_totper_02.png) no-repeat right center;
          background-size: 8px;
        }
      }
    }
  }
}
</style>
